import React, { useContext } from 'react';
import AppContext from '../contexts/AppContext';

const ProductTable = ({ products }) => {
  const { cart, updateQuantity } = useContext(AppContext);

  const getQuantity = productId => {
    const item = cart.find(i => i.productId === productId);
    return item ? item.quantity : 0;
  };

  const grouped = products.reduce((acc, product) => {
    const cat = product.category || "Others";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(product);
    return acc;
  }, {});


  return (
    <>
      <div>
        {Object.entries(grouped).map(([category, items]) => (
          <div key={category} className="mb-5">
            <h4 className="text-capitalize fw-bold border-bottom pb-2 mb-3">
              🎆 {category}
            </h4>

            <div className="table-responsive">
              <table className="table table-borderless align-middle ak-product-table">
                <thead className="table-dark text-uppercase small">
                  <tr>
                    <th>Image</th>
                    <th>Product Name</th>
                    <th>Pack</th>
                    <th>Original Price</th>
                    <th>Offer Price</th>
                    <th className="text-center">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map(product => (
                    <tr key={product._id} className="ak-product-row">
                      <td data-label="Image">
                        <img
                          src={product.imageUrl}
                          alt={product.name}
                          className="rounded"
                          style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                        />
                      </td>
                      <td data-label="Product Name">{product.name}</td>
                      <td data-label="Pack">{product.pack}</td>
                      <td data-label="Original Price" className="text-muted text-decoration-line-through">
                        ₹{product.originalPrice}
                      </td>
                      <td data-label="Offer Price" className="fw-bold text-danger">
                        ₹{product.offerPrice}
                      </td>
                      <td data-label="Quantity">
                        <div className="d-flex align-items-center gap-2">
                          <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => updateQuantity(product, getQuantity(product._id) - 1)}
                          >-</button>
                          <span className="fw-bold">{getQuantity(product._id)}</span>
                          <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => updateQuantity(product, getQuantity(product._id) + 1)}
                          >+</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        ))}
      </div>
    </>
  );
};

export default ProductTable;